/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class SalesApiConfiguration {
  rootUrl: string = '/';
}

/**
 * Parameters for `SalesApiModule.forRoot()`
 */
export interface SalesApiConfigurationParams {
  rootUrl?: string;
}
